import { connect } from 'react-redux';
import SourceManagement from './components/SourceManagement';
import {
  loadSource,
  createFileSource,
  updateFileSource,
} from '../../redux/actions/source';
import {
  loadIOCSFromSpecificCollection,
  loadIOCSPageFromSpecificCollection,
  deleteIOCFromCollection,
  resetEnrichment,
} from '../../redux/actions/ioc';
import {
  consumeFileData,
  consumeFeedData,
  exportFeed,
  verifyAuth,
} from '../../redux/actions/feed';
import { resetTagSearch, searchForTags } from '../../redux/actions/tags';
import { selectFeedItemFields } from '../../redux/selectors/filters';
import { selectFoundTags } from '../../redux/selectors/tags';

const mapStateToProps = (state) => ({
  user: state.user.user,
  source: state.source.source,
  feedIOCList: state.ioc.feedIOCList,
  feedIOCListCount: state.ioc.feedIOCListCount,
  feedIOCListStatus: state.ioc.feedIOCListStatus,
  feedItemFields: selectFeedItemFields(state),
  consumeStatus: state.feed.consumeStatus,
  foundTags: selectFoundTags(state),
  searchStatus: state.tags.searchStatus,
  feedTable: state.feed.tableData,
  testStatus: state.feed.testStatus,
});

const mapDispatchToProps = {
  loadSource,
  loadIOCSFromSpecificCollection,
  loadIOCSPageFromSpecificCollection,
  deleteIOCFromCollection,
  resetEnrichment,
  consumeFileData,
  consumeFeedData,
  exportFeed,
  verifyAuth,
  createFileSource,
  updateFileSource,
  searchForTags,
  resetTagSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceManagement);
